import { Component } from "preact";
import PropTypes from "prop-types";
import { combineClasses, get } from "@green24/npm-javascript-utils";
import MessageModal from "../../components/shared/Modal/MessageModal";
import { Price } from "../../components/components";
import { E_BoxRoute_Action, E_Route } from "../../models/constants/Enum_Routes";
import { ErrorUtils } from "../../utils/ErrorUtils";
import { AppUtils } from "../../utils/AppUtils";
import { E_Box_OpenMode } from "../../models/constants/Enums_Storage";
import { sessionServices } from "../../services/session-services";
import { route } from "preact-router";
import PaymentTerminal from "../../components/shared/PaymentTerminal";
import withSession from "../../components/shared/hoc/withSession";
import Interpret from "../../components/shared/Localization/Interpret";
import { E_Payment_Mode } from "../../models/constants/Enums_Payment";
import Loading from "../../components/shared/Loading";

class BoxRentOvertimePage extends Component {
	render(
		{className, style, sessionID, additionalPaymentAmount, session, physicalReference, onSession},
		{opening}
	) {
		return (
			<section className={combineClasses("box-rent-overtime-page", className)} style={style}>
				<PaymentTerminal
					title={"session.overtime.title"}
					contentHeaderLeftSlot={
						<div className={"selected-service-type"}>
							{get(session, "service.physicalReference")}
						</div>
					}
					contentHeaderSlot={
						<div className={"selected-time-bracket"}>
							<Interpret id={"session.penalty.price"} params={{
								price: session && (
									<b><Price value={additionalPaymentAmount} currency={get(session, "tariff.currency")}/></b>
								),
							}}/>
						</div>
					}
					idleContentSlot={<>
						<h2><Interpret id={"session.penalty.title"}/></h2>

						<p><Interpret id={"session.penalty.message"}/></p>

						<p className={"addendum"}><Interpret id={"termsAgreeNotice"}/></p>
					</>}
					sessionID={sessionID}
					session={session}
					physicalReference={physicalReference}
					paymentMode={E_Payment_Mode.ADDITIONAL_PAYMENT}
					onSession={onSession}
					onPaid={() => this._openBox()}
				/>

				{opening && <Loading title={"box.open.pending"} className={"with-background"}/>}
			</section>
		);
	}

	_openBox() {
		const {session} = this.props;

		this.setState({opening: true});
		sessionServices.openBoxByPin(
			session.pin,
			E_Box_OpenMode.OPEN_DELAYED,
			AppUtils.simulateBoxOpening
		).then(data => {
			route(E_Route.BOX_OPENING(E_BoxRoute_Action.OPEN, {
				timeout: data.openDelaySeconds,
				physicalReference: get(data.session, "service.physicalReference"),
			}));
		}, (res) => {
			this.setState({opening: false});

			//TBD: More specific error?
			let error = ErrorUtils.getErrorFromResponse(res);
			window.modal.open(
				<MessageModal
					icon={error.icon}
					title={error.title}
					titleTranslated={error.titleTranslated}
					message={"box.open.error.message"}
					actionButtons={() => [
						{
							className: "close",
							text: "support.contact",
							href: E_Route.HELP,
							action: () => window.modal.close(),
						},
						{
							className: "confirm",
							text: "retry",
							action: () => {
								window.modal.close();

								this._openBox();
							},
						},
					]}
				/>,
				{
					accent: "error",
				},
			);
		});
	}

	static get propTypes() {
		return {
			className: PropTypes.string,
			style: PropTypes.object,
			children: PropTypes.any,

			additionalPaymentAmount: PropTypes.number,
			physicalReference: PropTypes.string,

			sessionID: PropTypes.number,
			session: PropTypes.object,
		}
	}
}

export default withSession(BoxRentOvertimePage, true, true);
